import { notification } from 'antd';
import type { ArgsProps } from 'antd/lib/notification';
import { isNil } from 'ramda';
import { getErrorMessage } from './getErrorMessage';

export const NOTIFY_DEFAULT_PROPS: ArgsProps = {
  message: '',
  duration: 2,
};

/**
 * @deprecated Use `useAppNotifications` instead.
 */
export const notifySuccess = (argsProps: ArgsProps): void =>
  notification.success({
    ...NOTIFY_DEFAULT_PROPS,
    ...argsProps,
  });

/**
 * @deprecated Use `useAppNotifications` instead.
 */
export const notifyError = (error: unknown, argsProps?: ArgsProps): void =>
  notification.error({
    ...NOTIFY_DEFAULT_PROPS,
    message: 'There was an error',
    ...(isNil(error) ? {} : { description: getErrorMessage(error) }),
    ...argsProps,
  });

/**
 * @deprecated Use `useAppNotifications` instead.
 */
export const notifyWarning = (argsProps: ArgsProps): void =>
  notification.warning({
    ...NOTIFY_DEFAULT_PROPS,
    ...argsProps,
  });
